import {cn} from '@/lib/utils'

export function MicroLabel({children, className}: {children: React.ReactNode; className?: string}) {
  return (
    <p className={cn('font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase', className)}>
      {children}
    </p>
  )
}
